import { getBusinessTypesApi } from "@/api/admin/business-types";
import { getCorporateGroupsApi } from "@/api/admin/corporate-group";
import { getMachinesApi } from "@/api/admin/machines";
import { getSectorsApi } from "@/api/admin/sectors";
import { getUnitsApi } from "@/api/admin/units";

export const types = {
  STORE_MODULE: "company-report",

  CORPORATE_GROUP: "CORPORATE_GROUP",
  UNIT: "UNIT",
  BUSINESS_TYPE: "BUSINESS_TYPE",
  SECTOR: "SECTOR",
  MACHINE: "MACHINE",

  IS_FILTER_LOADING: "IS_FILTER_LOADING",

  SET_UNIT_ITEMS: "SET_UNIT_ITEMS",
  SET_UNIT_SELECTED: "SET_UNIT_SELECTED",
  SET_UNIT_LOADING: "SET_UNIT_LOADING",
  SET_UNIT_LINKS: "SET_UNIT_LINKS",
  SET_UNIT_META: "SET_UNIT_META",

  SET_CORPORATE_GROUP_ITEMS: "SET_CORPORATE_GROUP_ITEMS",
  SET_CORPORATE_GROUP_SELECTED: "SET_CORPORATE_GROUP_SELECTED",
  SET_CORPORATE_GROUP_LOADING: "SET_CORPORATE_GROUP_LOADING",
  SET_CORPORATE_GROUP_META: "SET_CORPORATE_GROUP_META",
  SET_CORPORATE_GROUP_LINKS: "SET_CORPORATE_GROUP_LINKS",

  SET_BUSINESS_TYPE_SEARCH_QUERY: "SET_BUSINESS_TYPE_SEARCH_QUERY",
  SET_BUSINESS_TYPE_ITEMS: "SET_BUSINESS_TYPE_ITEMS",
  SET_BUSINESS_TYPE_LOADING: "SET_BUSINESS_TYPE_LOADING",
  SET_BUSINESS_TYPE_SELECTED: "SET_BUSINESS_TYPE_SELECTED",
  SET_BUSINESS_TYPE_LINKS: "SET_BUSINESS_TYPE_LINKS",
  SET_BUSINESS_TYPE_META: "SET_BUSINESS_TYPE_META",

  SET_SECTOR_SEARCH_QUERY: "SET_SECTOR_SEARCH_QUERY",
  SET_SECTOR_ITEMS: "SET_SECTOR_ITEMS",
  SET_SECTOR_LOADING: "SET_SECTOR_LOADING",
  SET_SECTOR_SELECTED: "SET_SECTOR_SELECTED",
  SET_SECTOR_LINKS: "SET_SECTOR_LINKS",
  SET_SECTOR_META: "SET_SECTOR_META",

  SET_MACHINE_SELECTED: "SET_MACHINE_SELECTED",
  SET_MACHINE_ITEMS: "SET_MACHINE_ITEMS",
  SET_MACHINE_LOADING: "SET_MACHINE_LOADING",
  SET_MACHINE_LINKS: "SET_MACHINE_LINKS",
  SET_MACHINE_META: "SET_MACHINE_META",

  FETCH_CORPORATE_GROUPS: "FETCH_CORPORATE_GROUPS",
  FETCH_UNITS: "FETCH_UNITS",
  FETCH_MACHINES: "FETCH_MACHINES",
  FETCH_SECTORS: "FETCH_SECTORS",
  FETCH_BUSINESS_TYPES: "FETCH_BUSINESS_TYPES",
};

const state = {
  CORPORATE_GROUP: {
    selected: null,
    items: [""],
    loading: false,
    links: null,
    meta: null,
  },
  UNIT: {
    selected: null,
    items: [""],
    loading: false,
    links: null,
    meta: null,
  },
  MACHINE: {
    selected: null,
    items: [""],
    loading: false,
    links: null,
    meta: null,
  },
  BUSINESS_TYPE: {
    searchQuery: "",
    items: [""],
    loading: false,
    selected: null,
    links: null,
    meta: null,
  },
  SECTOR: {
    searchQuery: "",
    items: [""],
    loading: false,
    selected: null,
    links: null,
    meta: null,
  },
};

const getters = {
  IS_FILTER_LOADING: (state) =>
    state.CORPORATE_GROUP.loading ||
    state.UNIT.loading ||
    state.MACHINE.loading,
};

const actions = {
  async fetchCorporateGroups(
    { commit },
    {
      // page = 1,
      // perPage = 10,
      // searchQuery = "",
      signal = null,
      returnResponse = false,
      userRole="",
    } = {}
  ) {
    const response = await getCorporateGroupsApi({
      // page,
      // perPage,
      // searchQuery,
      signal,
      userRole,
    });
    commit(types.SET_CORPORATE_GROUP_ITEMS, ["", ...response.data.data]);
    // commit(types.SET_CORPORATE_GROUP_META, response.data.meta);
    // commit(types.SET_CORPORATE_GROUP_LINKS, response.data.links);
    if (returnResponse) {
      return response;
    }
  },

  async fetchUnits(
    { commit },
    {
      page = 1,
      perPage = 10,
      searchQuery = "",
      reduced = false,
      signal = null,
      businessTypes,
      returnResponse = false,
      corporateGroupIds,
    } = {}
  ) {
    const response = await getUnitsApi({
      page,
      perPage,
      searchQuery,
      reduced,
      businessTypes,
      signal,
      corporateGroupIds,
    }); 
    commit(types.SET_UNIT_ITEMS, ["", ...response.data.data]);
    commit(types.SET_UNIT_META, response.data.meta);
    commit(types.SET_UNIT_LINKS, response.data.links);
    if (returnResponse) {
      return response;
    }
  },

  async fetchMachines(
    { commit },
    {
      sectors,
      // page = 1,
      // perPage = 10,
      // searchQuery = "",
      // signal = null,
      unitIds,
      returnResponse = false,
    } = {}
  ) {
    const response = await getMachinesApi({
      // page,
      // perPage,
      // searchQuery,
      // signal,
      sectors,
      unitIds,
    });
    commit(types.SET_MACHINE_ITEMS, ["", ...response.data.data]);
    // commit(types.SET_MACHINE_META, response.data.meta);
    // commit(types.SET_MACHINE_LINKS, response.data.links);
    if (returnResponse) {
      return response;
    }
  },

  async fetchSectors(
    { commit },
    {
      unitIds,
      page = 1,
      perPage = 10,
      searchQuery = "",
      signal = null,
      returnResponse = false,
    } = {}
  ) {
    const response = await getSectorsApi({
      unitIds,
      page,
      perPage,
      searchQuery,
      signal,
    });
    commit(types.SET_SECTOR_ITEMS, ["", ...response.data.data]);
    commit(types.SET_SECTOR_META, response.data.meta);
    commit(types.SET_SECTOR_LINKS, response.data.links);
    if (returnResponse) {
      return response;
    }
  },

  async fetchBusinessTypes(
    { commit },
    {
      corporateGroupIds,
      page = 1,
      perPage = 10,
      searchQuery = "",
      signal = null,
      returnResponse = false,
    } = {}
  ) {
    const response = await getBusinessTypesApi({
      corporateGroupIds,
      page,
      perPage,
      searchQuery,
      signal,
    });
    commit(types.SET_BUSINESS_TYPE_ITEMS, ["", ...response.data.data]);
    commit(types.SET_BUSINESS_TYPE_META, response.data.meta);
    commit(types.SET_BUSINESS_TYPE_LINKS, response.data.links);
    if (returnResponse) {
      return response;
    }
  },
};

const mutations = {
  SET_CORPORATE_GROUP_ITEMS(state, data) {
    state.CORPORATE_GROUP.items = data;
  },
  SET_UNIT_ITEMS(state, data) {
    state.UNIT.items = data;
  },
  SET_BUSINESS_TYPE_SEARCH_QUERY(state, data) {
    state.BUSINESS_TYPE.searchQuery = data;
  },
  SET_SECTOR_SEARCH_QUERY(state, data) {
    state.SECTOR.searchQuery = data;
  },
  SET_CORPORATE_GROUP_SELECTED(state, data) {
    state.CORPORATE_GROUP.selected = data;
  },
  SET_UNIT_SELECTED(state, data) {
    state.UNIT.selected = data;
  },
  SET_CORPORATE_GROUP_LOADING(state, data) {
    state.CORPORATE_GROUP.loading = data;
  },
  SET_UNIT_LOADING(state, data) {
    state.UNIT.loading = data;
  },
  SET_UNIT_LINKS(state, data) {
    state.UNIT.links = data;
  },
  SET_UNIT_META(state, data) {
    state.UNIT.meta = data;
  },
  SET_CORPORATE_GROUP_META(state, data) {
    state.CORPORATE_GROUP.meta = data;
  },
  SET_CORPORATE_GROUP_LINKS(state, data) {
    state.CORPORATE_GROUP.links = data;
  },
  SET_MACHINE_SELECTED(state, data) {
    state.MACHINE.selected = data;
  },
  SET_MACHINE_ITEMS(state, data) {
    state.MACHINE.items = data;
  },
  SET_MACHINE_LOADING(state, data) {
    state.MACHINE.loading = data;
  },
  SET_MACHINE_LINKS(state, data) {
    state.MACHINE.links = data;
  },
  SET_MACHINE_META(state, data) {
    state.MACHINE.meta = data;
  },
  SET_SECTOR_ITEMS(state, data) {
    state.SECTOR.items = data;
  },
  SET_SECTOR_LOADING(state, data) {
    state.SECTOR.loading = data;
  },
  SET_SECTOR_SELECTED(state, data) {
    state.SECTOR.selected = data;
  },
  SET_BUSINESS_TYPE_ITEMS(state, data) {
    state.BUSINESS_TYPE.items = data;
  },
  SET_BUSINESS_TYPE_LOADING(state, data) {
    state.BUSINESS_TYPE.loading = data;
  },
  SET_BUSINESS_TYPE_SELECTED(state, data) {
    state.BUSINESS_TYPE.selected = data;
  },
  SET_BUSINESS_TYPE_LINKS(state, data) {
    state.BUSINESS_TYPE.links = data;
  },
  SET_BUSINESS_TYPE_META(state, data) {
    state.BUSINESS_TYPE.meta = data;
  },
  SET_SECTOR_LINKS(state, data) {
    state.SECTOR.links = data;
  },
  SET_SECTOR_META(state, data) {
    state.SECTOR.meta = data;
  },
};

export default {
  namespaced: true,
  state: {
    [types.CORPORATE_GROUP]: state.CORPORATE_GROUP,
    [types.UNIT]: state.UNIT,
    [types.BUSINESS_TYPE]: state.BUSINESS_TYPE,
    [types.SECTOR]: state.SECTOR,
    [types.MACHINE]: state.MACHINE,
    [types.SECTOR]: state.SECTOR,
    [types.BUSINESS_TYPE]: state.BUSINESS_TYPE,
  },
  getters: {
    [types.IS_FILTER_LOADING]: getters.IS_FILTER_LOADING,
  },
  actions: {
    [types.FETCH_CORPORATE_GROUPS]: actions.fetchCorporateGroups,
    [types.FETCH_UNITS]: actions.fetchUnits,
    [types.FETCH_MACHINES]: actions.fetchMachines,
    [types.FETCH_SECTORS]: actions.fetchSectors,
    [types.FETCH_BUSINESS_TYPES]: actions.fetchBusinessTypes,
  },
  mutations: {
    [types.SET_SECTOR_LINKS]: mutations.SET_SECTOR_LINKS,
    [types.SET_SECTOR_META]: mutations.SET_SECTOR_META,
    [types.SET_CORPORATE_GROUP_ITEMS]: mutations.SET_CORPORATE_GROUP_ITEMS,
    [types.SET_UNIT_ITEMS]: mutations.SET_UNIT_ITEMS,
    [types.SET_BUSINESS_TYPE_SEARCH_QUERY]:
      mutations.SET_BUSINESS_TYPE_SEARCH_QUERY,
    [types.SET_SECTOR_SEARCH_QUERY]: mutations.SET_SECTOR_SEARCH_QUERY,
    [types.SET_CORPORATE_GROUP_SELECTED]:
      mutations.SET_CORPORATE_GROUP_SELECTED,
    [types.SET_UNIT_SELECTED]: mutations.SET_UNIT_SELECTED,
    [types.SET_CORPORATE_GROUP_LOADING]: mutations.SET_CORPORATE_GROUP_LOADING,
    [types.SET_UNIT_LOADING]: mutations.SET_UNIT_LOADING,
    [types.SET_UNIT_LINKS]: mutations.SET_UNIT_LINKS,
    [types.SET_UNIT_META]: mutations.SET_UNIT_META,
    [types.SET_CORPORATE_GROUP_META]: mutations.SET_CORPORATE_GROUP_META,
    [types.SET_CORPORATE_GROUP_LINKS]: mutations.SET_CORPORATE_GROUP_LINKS,
    [types.SET_MACHINE_ITEMS]: mutations.SET_MACHINE_ITEMS,
    [types.SET_MACHINE_LOADING]: mutations.SET_MACHINE_LOADING,
    [types.SET_MACHINE_LINKS]: mutations.SET_MACHINE_LINKS,
    [types.SET_MACHINE_META]: mutations.SET_MACHINE_META,
    [types.SET_MACHINE_SELECTED]: mutations.SET_MACHINE_SELECTED,
    [types.SET_SECTOR_ITEMS]: mutations.SET_SECTOR_ITEMS,
    [types.SET_SECTOR_LOADING]: mutations.SET_SECTOR_LOADING,
    [types.SET_SECTOR_SELECTED]: mutations.SET_SECTOR_SELECTED,
    [types.SET_BUSINESS_TYPE_ITEMS]: mutations.SET_BUSINESS_TYPE_ITEMS,
    [types.SET_BUSINESS_TYPE_LOADING]: mutations.SET_BUSINESS_TYPE_LOADING,
    [types.SET_BUSINESS_TYPE_SELECTED]: mutations.SET_BUSINESS_TYPE_SELECTED,
    [types.SET_BUSINESS_TYPE_LINKS]: mutations.SET_BUSINESS_TYPE_LINKS,
    [types.SET_BUSINESS_TYPE_META]: mutations.SET_BUSINESS_TYPE_META,
  },
};
